// @flow

import type { GenericEventConfig } from '@chatchamp/chatchamp-types'

import { logger } from '../../../common'

export function isGaAvailable (): boolean {
  return (typeof window.gtag === 'function')
}

export function isGaDataLayerAvailable (): boolean {
  return (typeof window.dataLayer === 'object')
}

export function pushEventToDataLayer (gaEvent: GenericEventConfig) {
  const eventName = gaEvent.customEventName ?? gaEvent.eventName

  logger.info(`Logging GA in data layer: ${eventName} -> ${JSON.stringify(gaEvent.payload)}`)
  window.dataLayer.push({
    event: eventName,
    ...gaEvent.payload
  })
}

function pushEventToGtag (gaEvent: GenericEventConfig, googleAnalyticsId: ?string) {
  const params = { ...gaEvent.payload }
  const eventName = gaEvent.customEventName ?? gaEvent.eventName
  if (googleAnalyticsId) params.send_to = googleAnalyticsId

  logger.info(`Logging GA${googleAnalyticsId ? ` with trackingId ${googleAnalyticsId}` : ''}: ${eventName} -> ${JSON.stringify(params)}`)
  window.gtag('event', eventName, params)
}

export function fireGoogleAnalyticsEvent (gaEvent: GenericEventConfig, googleAnalyticsId: ?string = null) {
  try {
    pushEventToGtag(gaEvent, googleAnalyticsId)
  } catch (e) {
    logger.error(e)
  }
}
